





























































import { Vue, Component, Prop } from 'vue-property-decorator';
import ExpandableControl from './ExpandableControl.vue';
import ButtonsPanel from './ButtonsPanel.vue';
import VerticalSeparator from './VerticalSeparator.vue';
import { ImageAlignment } from './constants';

@Component({
  components: {
    ExpandableControl,
    ButtonsPanel,
    VerticalSeparator
  }
})
export default class ImageAlignmentToolbar extends Vue {
  @Prop({ default: false }) show!: boolean;

  imageAlignment = ImageAlignment;

  toggle() {
    this.$emit('alignment-toolbar:toggle');
  }

  collapse() {
    this.$emit('alignment-toolbar:collapse');
  }

  onChoose(data: ImageAlignment) {
    this.$emit('alignment-toolbar:choose', data);
  }
}
